/* CDNCE fit guide — size finder for snippets/cdnce-fit-guide.liquid.
   Lengths are in sixteenths of an inch (10 1/2" = 168).
   The main button adds the recommended size straight to the cart (Dawn cart drawer / notification). */
(function () {
  'use strict';

  function frac(n) {
    var whole = Math.floor(n / 16), r = n % 16;
    if (!r) return whole + '"';
    var a = r, d = 16;
    while (a % 2 === 0) { a /= 2; d /= 2; }
    return whole + ' ' + a + '/' + d + '"';
  }

  function parseNames(str) {
    return (str || 'Size').split(',')
      .map(function (n) { return n.trim().toLowerCase(); })
      .filter(Boolean);
  }

  // Mirrors the chosen size in the buy box (Dawn radios or dropdowns) so the page stays consistent.
  function selectSize(names, size) {
    document.querySelectorAll('variant-selects, variant-radios').forEach(function (picker) {
      var radios = picker.querySelectorAll('input[type="radio"]');
      for (var i = 0; i < radios.length; i++) {
        var r = radios[i], rn = (r.name || '').toLowerCase();
        if (r.value === size && names.some(function (n) { return rn.indexOf(n) === 0; })) {
          if (!r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
          return;
        }
      }
      var selects = picker.querySelectorAll('select');
      for (var j = 0; j < selects.length; j++) {
        var s = selects[j], sn = (s.name || '').toLowerCase();
        var label = s.id ? document.querySelector('label[for="' + s.id + '"]') : null;
        var lt = label ? label.textContent.trim().toLowerCase() : '';
        var hit = names.some(function (n) { return sn.indexOf(n) !== -1 || lt.indexOf(n) === 0; });
        if (!hit) continue;
        for (var k = 0; k < s.options.length; k++) {
          if (s.options[k].value === size) {
            if (s.value !== size) { s.value = size; s.dispatchEvent(new Event('change', { bubbles: true })); }
            return;
          }
        }
      }
    });
    document.dispatchEvent(new CustomEvent('cdnce:size-selected', { detail: { size: size } }));
  }

  function addToCart(variantId) {
    var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    var cart = document.querySelector('cart-drawer') || document.querySelector('cart-notification');
    var body = { id: variantId, quantity: 1 };
    if (cart && typeof cart.getSectionsToRender === 'function') {
      body.sections = cart.getSectionsToRender().map(function (s) { return s.id; });
      body.sections_url = window.location.pathname;
    }
    return fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (res) { return res.json(); })
      .then(function (json) {
        if (json.status) throw new Error(json.description || json.message || 'Could not add to cart.');
        if (cart && typeof cart.renderContents === 'function') {
          if (cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
          cart.renderContents(json);
          if (typeof window.publish === 'function' && window.PUB_SUB_EVENTS) {
            window.publish(window.PUB_SUB_EVENTS.cartUpdate, { source: 'cdnce-fit-guide', productVariantId: variantId, cartData: json });
          }
        } else {
          window.location.href = root + 'cart';
        }
      });
  }

  function init(root) {
    if (!root || root.dataset.cfgReady) return;
    root.dataset.cfgReady = '1';

    var slider = root.querySelector('[data-slider]');
    var lenEl = root.querySelector('[data-len]');
    var recEl = root.querySelector('[data-rec]');
    var labelEl = root.querySelector('[data-label]');
    var pick = root.querySelector('[data-pick]');
    var confirmEl = root.querySelector('[data-confirm]');
    var rows = Array.prototype.slice.call(root.querySelectorAll('[data-row]'))
      .sort(function (a, b) { return +a.dataset.max - +b.dataset.max; });
    var minFit = +root.dataset.minFit || 0;
    var names = parseNames(root.dataset.optionName);
    var current = null, variant = null, busy = false;
    var touched = false; // stays blank until the shopper uses the slider or the - / + buttons
    var toggle = root.parentElement && root.parentElement.querySelector('[data-cfg-toggle]');

    function setOpen(open) {
      root.hidden = !open;
      if (toggle) toggle.setAttribute('aria-expanded', open ? 'true' : 'false');
    }
    function openFinder() {
      setOpen(true);
      root.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }
    document.querySelectorAll('a[href="#find-your-size"]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        e.preventDefault();
        if (root.hidden) openFinder(); else setOpen(false);
      });
    });
    if (window.location.hash === '#find-your-size') setOpen(true);
    window.addEventListener('hashchange', function () {
      if (window.location.hash === '#find-your-size') openFinder();
    });
    root.addEventListener('cdnce:open-finder', openFinder);

    if (!slider || !rows.length) return;

    var product = { options: [], variants: [] };
    var dataEl = root.parentElement && root.parentElement.querySelector('[data-cfg-product]');
    try { if (dataEl) product = JSON.parse(dataEl.textContent); } catch (e) { /* keep empty */ }
    var sizeIndex = -1;
    (product.options || []).forEach(function (o, i) {
      if (sizeIndex === -1 && names.indexOf(String(o).trim().toLowerCase()) !== -1) sizeIndex = i;
    });

    function findVariant(size) {
      if (sizeIndex === -1) return null;
      for (var i = 0; i < product.variants.length; i++) {
        if (product.variants[i].options[sizeIndex] === size) return product.variants[i];
      }
      return null;
    }

    root.querySelector('[data-tick-min]').textContent = frac(+slider.min);
    root.querySelector('[data-tick-max]').textContent = frac(+slider.max);

    function setButton() {
      if (!touched) { pick.disabled = true; pick.textContent = 'Set your foot length'; return; }
      if (!current) { pick.disabled = true; pick.textContent = 'No size available'; return; }
      var size = current.dataset.size;
      if (!variant) { pick.disabled = true; pick.textContent = 'Size ' + size + ' unavailable'; return; }
      if (!variant.available) { pick.disabled = true; pick.textContent = 'Size ' + size + ' sold out'; return; }
      pick.disabled = busy;
      pick.textContent = busy ? 'Adding\u2026' : 'Add size ' + size + ' to cart \u00b7 ' + variant.price;
    }

    function update() {
      var v = +slider.value;
      confirmEl.textContent = '';
      current = null; variant = null;
      rows.forEach(function (r) { r.classList.remove('is-hit'); });
      root.classList.toggle('is-set', touched);

      if (!touched) {
        lenEl.textContent = '\u2014';
        recEl.textContent = '';
        labelEl.textContent = 'Slide or tap \u2212 / + to set your foot length.';
        setButton();
        return;
      }
      lenEl.textContent = frac(v);

      if (v < minFit) {
        recEl.textContent = '\u2014';
        labelEl.textContent = 'Smaller than our smallest size. We don\u2019t make your size yet.';
      } else {
        for (var i = 0; i < rows.length; i++) {
          if (v <= +rows[i].dataset.max) { current = rows[i]; break; }
        }
        if (!current) {
          recEl.textContent = '\u2014';
          labelEl.textContent = 'Larger than our largest size. We don\u2019t make your size yet.';
        } else {
          current.classList.add('is-hit');
          recEl.textContent = 'Size ' + current.dataset.size;
          labelEl.textContent = v === +current.dataset.max
            ? 'Right on the line, so we recommend the smaller size.'
            : 'Your recommended size.';
          variant = findVariant(current.dataset.size);
        }
      }
      setButton();
    }

    slider.addEventListener('input', function () { touched = true; update(); });
    root.querySelectorAll('[data-step]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        touched = true;
        slider.value = Math.min(+slider.max, Math.max(+slider.min, +slider.value + +btn.dataset.step));
        update();
      });
    });

    pick.addEventListener('click', function () {
      if (!current || !variant || !variant.available || busy) return;
      var size = current.dataset.size;
      busy = true; setButton(); confirmEl.textContent = '';
      selectSize(names, size);
      addToCart(variant.id)
        .then(function () { confirmEl.textContent = 'Size ' + size + ' added to your cart.'; })
        .catch(function (err) { confirmEl.textContent = err.message || 'Something went wrong. Please try again.'; })
        .then(function () { busy = false; setButton(); });
    });

    update();
  }

  function initAll() { document.querySelectorAll('[data-cfg]').forEach(init); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initAll);
  else initAll();

  document.addEventListener('shopify:section:load', function (e) {
    init(e.target.querySelector('[data-cfg]'));
  });

  // In the theme editor, selecting the fit guide block opens the finder so it can be edited.
  document.addEventListener('shopify:block:select', function (e) {
    var root = e.target.querySelector && e.target.querySelector('[data-cfg]');
    if (root) root.dispatchEvent(new CustomEvent('cdnce:open-finder'));
  });
})();
